import { Service }			from "./../../Libs/Service";
import _					from "lodash";

import { Server } 			from "./Server";

let Localization = new Service({

	Name: "Localization",

	Events: {

		'Settings Selected': function(settings) {

			//this.updateParams();

		}

	},

	Actions: {

		'Localization': function(texts) {

			this.updateLocalization(texts);

			Broadcast.call("Localization Updated", [texts]);

			if (!this.loaded) Broadcast.call("Localization Loaded");

			this.loaded = true;

		}

	},

	init() {

		this.loaded = false;

		this.Localization = {};
		this.LocalizationByVersion = {};
		this.LocalizationByVersionByLocaleByCodename = {};

	},

	updateLocalization(texts) {

		let selected_version_localization_changes = [];

		_.each(texts, (text, text_id) => {

			if (!text) {

				text = this.Localization[text_id];

				delete this.Localization[text.id];
				if (this.LocalizationByVersion[text.version_id]) delete this.LocalizationByVersion[text.version_id][text.id];
				if (this.LocalizationByVersionByLocaleByCodename[text.version_id] && this.LocalizationByVersionByLocaleByCodename[text.version_id][text.locale]) delete this.LocalizationByVersionByLocaleByCodename[text.version_id][text.locale][text.codename];

			} else {

				this.Localization[text.id] = text;

				if (!this.LocalizationByVersion[text.version_id]) this.LocalizationByVersion[text.version_id] = {};
				this.LocalizationByVersion[text.version_id][text.id] = text;

				if (!this.LocalizationByVersionByLocaleByCodename[text.version_id]) this.LocalizationByVersionByLocaleByCodename[text.version_id] = {};
				if (!this.LocalizationByVersionByLocaleByCodename[text.version_id][text.locale]) this.LocalizationByVersionByLocaleByCodename[text.version_id][text.locale] = {};
				this.LocalizationByVersionByLocaleByCodename[text.version_id][text.locale][text.codename] = text;

				text.timestamp = new Date(text.timestamp);

			}

			Broadcast.call("Localization Updated", [text_id]);

			if (Version.SelectedVersion && text.version_id === Version.SelectedVersion.id) selected_version_localization_changes.push(text_id);

		});

		if (selected_version_localization_changes.length > 0) Broadcast.call("Selected Version Localization Updated", [selected_version_localization_changes]);

	},

	//Возвращаем тексты текущей версии проекта
	getSelectedVersionLocalization() {

		if (!Version.SelectedVersion) return null;

		return this.LocalizationByVersion[Version.SelectedVersion.id];

	},

	//Возвращаем тексты текущей версии проекта сгруппированно по локалям
	getSelectedVersionLocalizationByLocale() {

		if (!Version.SelectedVersion) return null;

		return this.LocalizationByVersionByLocaleByCodename[Version.SelectedVersion.id];

	},

	getSelectedVersionMergedLocalization() {

		let version_localization = this.getSelectedVersionLocalization();

		let merged_localization = {};

		_.each(version_localization, text => {

			if (!merged_localization[text.locale]) merged_localization[text.locale] = {};

			merged_localization[text.locale][text.codename] = this.getMergedLocalization(text);

		});

		return merged_localization;

	},

	getMergedLocalization(text) {

		return _.extend({text: text["new_message"] || text["message"]}, _.extend({}, text.Styles, text.NewStyles));

	},

	changeLocalizationMessage(versionId, locale, codename, text) {

		Server.sendToSocket({
			ChangeLocalizationMessage: {
				versionId,
				locale,
				codename,
				text
			}
		});

	},

	changeLocalizationStyle(versionId, locale, codename, styleName, styleValue) {

		styleValue = this.checkLocalizationStyle(styleName, styleValue);

		Server.sendToSocket({
			ChangeLocalizationStyle: {
				versionId,
				locale,
				codename,
				styleName,
				styleValue
			}
		});

	},

	checkLocalizationStyle(styleName, styleValue) {

		if (styleName === 'fontSize' && styleValue <= 0) styleValue = 1;
		if (['dropShadowDistance', 'letterSpacing', 'wordWrapWidth', 'strokeThickness', 'padding'].includes(styleName)) styleValue = parseInt(styleValue);

		return styleValue;

	}

});

//Делаем глобальную ссылку для дебага - чтобы в консоли был виден этот объект сразу
window.Localization = Localization;

export { Localization }

